// JournalConfig Reducer
import { SET_JOURNAL_CONFIG } from '../actions/JournalConfigActions';

const initialState = {
    config: {}
}

const journalConfigReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_JOURNAL_CONFIG:
            return { 
                ...state,
                config: action.payload 
            }
        default:
            return state;
    }
}

export default journalConfigReducer;
